/**
 * Chart 组件 Widget 类（6.2 BaseWidget 体系）
 * Chart（通用占位）/ BarChart / LineChart / PieChart / AreaChart / MetricCard
 */
import type { PropertyPaneConfig } from "@shared/types";

import { getMaterial } from "../materials";
import { BaseWidget } from "./base-widget";
import { buildMaterialPropertyPaneConfig } from "./property-pane";

function paneConfigFor(type: string, extraSections: PropertyPaneConfig[] = []): PropertyPaneConfig[] {
  return buildMaterialPropertyPaneConfig(getMaterial(type)?.propSchema ?? [], extraSections);
}

export class ChartWidget extends BaseWidget {
  getWidgetType(): string {
    return "Chart";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Chart");
  }
}

export class BarChartWidget extends BaseWidget {
  getWidgetType(): string {
    return "BarChart";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("BarChart");
  }
}

export class LineChartWidget extends BaseWidget {
  getWidgetType(): string {
    return "LineChart";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("LineChart");
  }
}

export class PieChartWidget extends BaseWidget {
  getWidgetType(): string {
    return "PieChart";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("PieChart");
  }
}

export class AreaChartWidget extends BaseWidget {
  getWidgetType(): string {
    return "AreaChart";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("AreaChart");
  }
}

export class MetricCardWidget extends BaseWidget {
  getWidgetType(): string {
    return "MetricCard";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("MetricCard");
  }
}
